import { displayLog } from "../../Helper/helper";
import { SET_BIDS_FOR_INACTIVE_SELLER } from "../actionTypes";
import { BIDS_ACTION_TYPES } from "../actions/bids.action";
import ErrorMsg from "../../Fixures/errorMessages.json";
import { ORDER_DETAILS_OBJECT } from "../../Config/config";



const initialState = {
   isLoading: false,
   bidPricePerGallon: 0,
   freightCharges: 0,
   distance: 0,
   autoPriceEnabled: false,
   inActiveBids: [],
   taxDataOnOrder: {},
   taxAppliedData: {},
   orderDetails: ORDER_DETAILS_OBJECT,
   newBidsData: {
      totalRows: 0,
      bids: [],
   },
};

const bidsReducer = (state = initialState, action) => {
   switch (action.type) {
      case BIDS_ACTION_TYPES.GET_BID_INFO_FROM_ID:
         return {
            ...state,
            isLoading: true,
         };
      case BIDS_ACTION_TYPES.GET_BID_INFO_FROM_ID_DONE:
         return {
            ...state,
            bidPricePerGallon: action.payload.bidPricePerGallon || 0,
            freightCharges: action.payload.freightCharges || 0,
            distance: action.payload.distance || 0,
            orderDetails: action.payload || ORDER_DETAILS_OBJECT,
            isLoading: false,
         };
      case BIDS_ACTION_TYPES.GET_BID_INFO_FROM_ID_ERROR:
         displayLog("error", ErrorMsg.errorMsg.fetchingOrderDetailFailed)
         return {
            ...state,
            isLoading: false,
         };
      case SET_BIDS_FOR_INACTIVE_SELLER:
         return {
            ...state,
            inActiveBids: action.payload
         }
      case BIDS_ACTION_TYPES.GET_NEW_BIDS: {
         return { ...state, isLoading: true }
      }

      case BIDS_ACTION_TYPES.GET_NEW_BIDS_DONE: {
         const newState = structuredClone(state);
         newState.newBidsData.bids = action.payload.paginationData;
         newState.newBidsData.totalRows = action.payload.totalRecords;
         newState.isLoading = false;
         return newState;
      }
      case BIDS_ACTION_TYPES.GET_NEW_BIDS_ERROR: {
         return { ...state, isLoading: false }
      }
      case BIDS_ACTION_TYPES.GET_NEW_BIDS_ON_PAGE_CHANGE: {
         return state;
      }
      case BIDS_ACTION_TYPES.GET_NEW_BIDS_ON_PAGE_CHANGE_DONE: {
         const newState = structuredClone(state);
         newState.newBidsData.bids = action.payload.paginationData;
         return newState;
      }
      case BIDS_ACTION_TYPES.GET_NEW_BIDS_ON_PAGE_CHANGE_ERROR: {
         return state;
      }

      case BIDS_ACTION_TYPES.GET_NEW_BIDS_PER_PAGE_LIMIT_CHANGE: {
         return state;
      }

      case BIDS_ACTION_TYPES.GET_NEW_BIDS_PER_PAGE_LIMIT_CHANGE_DONE: {
         const newState = structuredClone(state);
         newState.newBidsData.bids = action.payload.paginationData;
         return newState;
      }

      case BIDS_ACTION_TYPES.GET_NEW_BIDS_PER_PAGE_LIMIT_CHANGE_ERROR: {
         return { ...state, isLoading: false };
      }

      case BIDS_ACTION_TYPES.GET_NEW_BIDS_FOR_SEARCHED_QUERY: {
         return { ...state, isLoading: true };
      }

      case BIDS_ACTION_TYPES.GET_NEW_BIDS_FOR_SEARCHED_QUERY_DONE: {
         const newState = structuredClone(state);
         newState.newBidsData.bids = action.payload.paginationData;
         newState.newBidsData.totalRows = action.payload.totalRecords;
         newState.isLoading = false;
         return newState;
      }

      case BIDS_ACTION_TYPES.GET_NEW_BIDS_FOR_SEARCHED_QUERY_ERROR: {
         return { ...state, isLoading: false };
      }

      case BIDS_ACTION_TYPES.GET_NEW_SORTED_BIDS: {
         return { ...state, isLoading: true };
      }

      case BIDS_ACTION_TYPES.GET_NEW_SORTED_BIDS_DONE: {
         const newState = structuredClone(state);
         newState.newBidsData.bids = action.payload.paginationData;
         newState.isLoading = false;
         return newState;
      }
      case BIDS_ACTION_TYPES.GET_NEW_SORTED_BIDS_ERROR: {
         return { ...state, isLoading: false };
      }

      default:
         return state;
   }
}

export default bidsReducer;